import { Layer, Box, Text, Anchor } from 'grommet';
import React from 'react';
import useTranslation from 'next-translate/useTranslation';

const NoDevicesFound = ({ setShow }) => {
	const { t } = useTranslation('default');
	return (
		<Layer onEsc={() => setShow(false)} onClickOutside={() => setShow(false)}>
			<Box pad="large">
				<Text weight="bold">{t('modals.no_devices_found')}</Text>
				<Text margin={{ top: '10px', bottom: '10px' }}>
					{t('modals.no_devices_found_description')}
				</Text>
				<Anchor
					onClick={() => setShow(false)}
					size="xsmall"
					label={t("modals.continue_no_mic")}
				/>
			</Box>
		</Layer>
	);
};

export default NoDevicesFound;
